import React from 'react'
import { Divider, Separator } from '@fs/zion-ui'
import NamesHeaderV2 from './NamesHeaderV2'
import FilterInput from '../../../../components/generic/FilterInput'
import PersonsList from '../../../../components/generic/personsList'

export default function PersonsListSection({ filterValue, onFilterChange, personsListProps }) {
  return (
    <>
      {/* Header with instructions and Manage Names button */}
      <NamesHeaderV2 />
      <Separator size="xs" />
      <FilterInput filterValue={filterValue} onFilterChange={onFilterChange} />
      <Divider />
      <Separator size="xxs" />
      <PersonsList {...personsListProps} />
    </>
  )
}
